import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "app",
  initialState: {
    header: {
      isOpen: true,
      isBanner: false,
    },
    burger: {
      isOpen: false,
    },
    language: "en",
  },
  reducers: {
    setIsOpenHeader(state, { payload }) {
      state.header.isOpen = payload;
    },
    setIsBannerHeader(state, { payload }) {
      state.header.isBanner = payload;
    },
    setLanguage(state, { payload }) {
      state.language = payload;
    },
    setIsOpenBurger(state, { payload }) {
      state.burger.isOpen = payload;
    },
  },
});

export const appReducer = appSlice.reducer;
export const {
  setIsOpenHeader,
  setLanguage,
  setIsBannerHeader,
  setIsOpenBurger,
} = appSlice.actions;
